import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../../utils/api';
import { postRejectMultipleEndpoint } from '../../../common/endpoints';

export const postRejectMultiple = createApi(postRejectMultipleEndpoint, 'POST');

const RejectMultiple = createSlice({
  name: 'RejectMultiple',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(postRejectMultiple.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(postRejectMultiple.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(postRejectMultiple.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default RejectMultiple.reducer;